import * as yup from 'yup';
import { MAX_DEFAULT_FIELD_SYMBOLS } from 'constants/general';
import { TStockFormValues } from './StockForm.types';
import { TStockTypeEnum } from 'api/stock/stock.types';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getStockFormSchema = (
  localize: TLocalize
): yup.ObjectSchema<TStockFormValues> =>
  yup
    .object({
      name: yup
        .string()
        .required(localize('validation.admin.stock.name.required') as string)
        .max(
          MAX_DEFAULT_FIELD_SYMBOLS,
          localize('validation.admin.stock.name.max', [
            String(MAX_DEFAULT_FIELD_SYMBOLS),
          ]) as string
        ),
      variation: yup
        .string()
        .default('')
        .defined()
        .max(
          MAX_DEFAULT_FIELD_SYMBOLS,
          localize('validation.admin.stock.variation.max', [
            String(MAX_DEFAULT_FIELD_SYMBOLS),
          ]) as string
        ),
      quantity: yup
        .number()
        .required(
          localize('validation.admin.stock.quantity.required') as string
        )
        .integer(localize('validation.admin.stock.quantity.integer') as string)
        .min(0, localize('validation.admin.stock.quantity.min') as string)
        .typeError(
          localize('validation.admin.stock.quantity.required') as string
        ),
      type: yup
        .mixed<TStockFormValues['type']>()
        .required(localize('validation.admin.stock.type.required') as string)
        .oneOf(
          [TStockTypeEnum.PhoneCase, TStockTypeEnum.Cup],
          localize('validation.admin.stock.type.oneof') as string
        ),
    })
    .required() as yup.ObjectSchema<TStockFormValues>;
